import { useContext } from 'react';
import useApi from './useApi';
import StoreContext from '../components/Store/context';

const useLogin = ({ onCompleted } = {}) => {
    const { setCredencials, setOpenModal } = useContext(StoreContext);

    const [signIn, signInInfo] = useApi({
        method: 'post',
        onCompleted: (response) => {
            if (response && response.data) {
                const data = response.data;
                const userAcess = {
                    id: data.id,
                    name: data.name,
                    lastName: data.lastName,
                    username: data.username,
                    notifications: data.notifications,
                    profile: data.profile,
                    sessionToken: data.sessionToken,
                    company: data.companyData ? data.companyData.id : null,
                    companyData: data.companyData,
                    isLicenseExpired: data.isLicenseExpired,
                    licenseEndTime: data.licenseEndTime,
                };

                setOpenModal(false);
                if (onCompleted) {
                    onCompleted(data);
                }
                setCredencials(userAcess);
            }
        },
    });

    const login = (values) => {
        setOpenModal(false);
        setCredencials(null);
        signIn({
            data: {
                username: values.username,
                password: values.password,
                company: values.company,
            },
            url: '/auth/user',
        });
    };

    const loginWithToken = (token) => {
        setOpenModal(false);
        setCredencials(null);
        signIn({
            data: { token },
            url: '/auth/signed-url',
        });
    };

    return { login, loginWithToken, signInInfo };
};

export default useLogin;
